// Welke deelname-rijen moeten hun einddatum aangepast krijgen na deze
// statuswissel?
//
// De einddatum staat per organisatie op haar eigen rij. Dat is met opzet: het
// programma mag pas de eindmeting sturen als IEDEREEN klaar is, en dat is alleen
// te zien als elke partij zijn eigen moment vastlegt.
//
// ALLEEN DE EIGEN RIJ. De rij van de andere organisatie is niet van ons; hem
// meenemen zou betekenen dat het ene klusbedrijf het traject van het andere
// afsluit. De opslagregel staat dat trouwens ook niet toe.
//
// AI-CONTEXT: See docs/features/energiearmoede-arnhem-ketensamenwerking.md

const AFGEROND = 'completed'

/**
 * @typedef {object} CompletionPatch
 * @property {string} docid - Het document dat bijgewerkt moet worden
 * @property {{CompletedAt: *}} patch - Wat eroverheen gaat
 */

/**
 * @param {object} [input]
 * @param {string} [input.toStatus] - De status ná de wissel
 * @param {Array<object>} [input.participations] - Deelname-rijen van dit huishouden
 * @param {string} [input.organisation] - CompagnyID van de organisatie die wijzigt
 * @param {*} [input.timestamp] - Server-tijdstempel voor het afrondmoment
 * @returns {Array<CompletionPatch>} Leeg betekent: er valt niets bij te werken
 */
const planParticipationCompletion = (input) => {
    const { toStatus, participations, organisation, timestamp } = input || {}
    if (!organisation || !Array.isArray(participations)) return []

    const afgerond = toStatus === AFGEROND

    return participations
        .filter((rij) => rij && rij.docid && rij.Organisation === organisation)
        // Idempotent: staat de einddatum al goed, dan schrijven we niet opnieuw.
        .filter((rij) => (afgerond ? !rij.CompletedAt : Boolean(rij.CompletedAt)))
        .map((rij) => ({ docid: rij.docid, patch: { CompletedAt: afgerond ? timestamp : null } }))
}

export default planParticipationCompletion
